/**
 * ProspectAboutSection Component
 * Wrapper for AboutSection component, plus the system-admin-only "Came from" import history.
 */

import type { ProspectResponse, TeamInfo } from "../../../../types/api";
import { AboutSection } from "./about/AboutSection";
import { ProspectCameFrom } from "../../../admin/prospect-provenance/ProspectCameFrom";

interface ProspectAboutSectionProps {
  prospect: ProspectResponse;
  onJerseyClick: (team: TeamInfo) => void;
  onRemoveTeam?: (teamId: string) => void;
  onAddTeam?: () => void;
}

export function ProspectAboutSection({
  prospect,
  onJerseyClick,
  onRemoveTeam,
  onAddTeam,
}: ProspectAboutSectionProps) {
  return (
    <>
      <AboutSection
        prospect={prospect}
        onJerseyClick={onJerseyClick}
        onRemoveTeam={onRemoveTeam}
        onAddTeam={onAddTeam}
      />
      {/* Renders (and fetches) only for a system admin. */}
      <ProspectCameFrom prospectId={prospect.id} />
    </>
  );
}
